var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2665 1.6H9.06651C8.79344 1.6 8.52038 1.704 8.31238 1.91253L1.91238 8.31253C1.49584 8.72907 1.49584 9.40427 1.91238 9.8208L6.17904 14.0875C6.59558 14.504 7.27078 14.504 7.68731 14.0875C7.89584 13.8789 13.8788 7.896 14.0873 7.68747C14.2958 7.47947 14.3998 7.2064 14.3998 6.93333V3.73333C14.3998 2.5552 13.4446 1.6 12.2665 1.6ZM12.2665 4.8C11.6772 4.8 11.1998 4.32267 11.1998 3.73333C11.1998 3.144 11.6772 2.66667 12.2665 2.66667C12.8558 2.66667 13.3332 3.144 13.3332 3.73333C13.3332 4.32267 12.8558 4.8 12.2665 4.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/priceTag.e6db6b70d2aec047ca82b9a8fa108b26.svg";
export { ForwardRef as ReactComponent };